// src/v3/ui/table-presets/symbol-presets.ts

import type { SmartTablePreset } from "../_deps";
import { symbolDefaultPreset } from "../_deps";

export const symbolPresets: SmartTablePreset[] = [
  symbolDefaultPreset,
  {
    id: "trading",
    name: "Trading",
    columns: [
      "symbol",
      "price",
      "autoStatus",
      "manualStatus",
      "marketCap",
      "volume",
    ],
    filters: [],
    sort: [],
    pageSize: 50,
  },
  {
    id: "fundamentals",
    name: "Fundamentals",
    columns: [
      "symbol",
      "price",
      "marketCap",
      "autoStatus",
      "manualStatus",
      "relations.industry.name",
      "financials.ratios.priceToEarningsRatioTTM",
      "financials.ratios.priceToBookRatioTTM",
      "financials.coefs.ROE.avg",
      "financials.cashFlow.freeCashFlow.sum",
    ],
    filters: [],
    sort: [],
    pageSize: 50,
  },
  {
    id: "valuation",
    name: "Valuation",
    columns: [
      "symbol",
      "price",
      "financials.values.discountRate",
      "financials.values.marginOfSafety",
      "financials.prices.fair.broad.min",
      "financials.prices.fair.broad.max",
      "financials.flags.isInterestingPrice",
    ],
    filters: [],
    sort: [],
    pageSize: 50,
  },
];
